// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-menu/~/rc-animate/lib/index.js
 ** module id = 380
 ** module chunks = 0
 **/